var $ = jQuery;
$(document).ready(function () {


  $('.product-single__gallery').each(function () {
    const $gallery = $(this);
    if ($gallery.children('.product-single__gallery-item').length === 1) {
      $gallery.addClass('product-single__gallery--static');
      return;
    }
    $gallery.flickity({
        imagesLoaded: true,
        groupCells: false,
        dragThreshold: 5,
        cellAlign: 'center',
        wrapAround: true,
        prevNextButtons: true,
        percentPosition: true, 
        pageDots: false,
        rightToLeft: false,
        autoPlay: false,
    });
  }); 
  

  //   setTimeout(function() {
  //   $(".custom-video-play").first().trigger("click");
  // }, 500);
  $('.gallery_img_text').flickity({ 
        imagesLoaded: true,
        groupCells: false,
        dragThreshold: 5,
        cellAlign: 'left',
        wrapAround: true,
        prevNextButtons: true,
        percentPosition: true, 
        pageDots: true,
        rightToLeft: false,
        autoPlay: 5000,
        autoPlay: false,
    });
     $('.st__full_slider ul').flickity({ 
        imagesLoaded: true,
        groupCells: false,
        dragThreshold: 5,
        cellAlign: 'left',
        wrapAround: true,
        prevNextButtons: true,
        percentPosition: true, 
        pageDots: false,
        rightToLeft: false,
        autoPlay: 5000,
        autoPlay: false,
    });
   /*** MINI CART  ***/
   $(document).on("click", ".submit_form", function(e) {
      e.preventDefault(); 
      var $form = $(this).closest("form");
      var $select = $form.find("select[name='id']");
      var $selectedOption = $select.find("option:selected");
      var variantId = $selectedOption.val() || $(this).data("pro-id");
      var minQty = $selectedOption.data("min-qty") || 1;

      $.ajax({
        type: "POST",
        url: window.Shopify.routes.root + "cart/add.js",
        data: JSON.stringify({
          id: variantId,
          quantity: minQty
        }),
        dataType: "json",      
        contentType: "application/json",
        success: function(data) {
          var url = new URL(window.location.href);
          url.searchParams.set("open_cart_n", "2");
          window.location.href = url.toString();
        },
        error: function(xhr, status, error) {
          console.error("Add to cart error:", error);
        }
      });
    });
  /*** MINI CART  ***/ 

  //Start Slider mobile
  function initFlickityMobile() {
    if ($(window).width() < 950) {
      
    $('.nt_ung').each(function() {
      const $section = $(this);
      const $list = $section.find('ul.multicolumn-list');
      const $items = $list.find('> li');

      if ($items.length > 1) {
        const $firstItem = $items.eq(0);

        const $flickityWrap = $('<div class="nt_ung_slider"></div>');

        $items.slice(1).appendTo($flickityWrap);

        $firstItem.after($flickityWrap);

        $flickityWrap.flickity({
          cellAlign: 'left',
          contain: true,
          pageDots: false,
          prevNextButtons: true,
          wrapAround: false,
          imagesLoaded: true,
          autoPlay: 5000,
          groupCells: false,
        });
      }
    });
      $(".cl_ld .multicolumn-list,.nt__unabhang .icon-with-text-wrapper .static-items-main .static-items, .nt_giesinger .static-items.swiper-wrapper").each(function () {
        if (!$(this).data('flickity')) {      
          $(this).flickity({
            pageDots: false,
            freeScroll: false,
            wrapAround: true,
            prevNextButtons: true,
            autoPlay: 5000,
            groupCells: false,
            cellAlign: 'center'
          });
        }
      });

      $(".gallery-grid,.richtige--st .multicolumn-list,.listbox--jobs .image-with-text .global-media-settings,ul.blog__posts.articles-wrapper,.slider--icons.icon-with-text .static-items-main .static-items,.nt_veranstaltungs .metaobject-list-verans,.has_slide_mb ul.collection-list, .has_slider .events-template #product-grid.grid.product-grid").each(function () {
        if (!$(this).data('flickity')) {
          $(this).flickity({
            pageDots: false,
            freeScroll: false,
            wrapAround: true,
            prevNextButtons: true,
            autoPlay: 5000,
            groupCells: false,
            adaptiveHeight: true,
            cellAlign: 'left'
          });
        }
      });
      $("#img_w_text_st:not(.no_slider) .no--img--12,.img_slider_mb .no--img--1").each(function () {
        if (!$(this).data('flickity')) {
          $(this).flickity({
            pageDots: false,
            freeScroll: false,
            wrapAround: false,
            prevNextButtons: true,
            autoPlay: 5000,
            groupCells: false,
            adaptiveHeight: true,
            cellAlign: 'center'
          });
        }
      });
    }
  }
  $(document).ready(initFlickityMobile);

  $(window).on('resize', function () {
    initFlickityMobile();
  });
  //End Slider mobile
  $(document).on('click', '.button-block-section .custom-button', function(e) {
    e.preventDefault(); 
  });
 $(document).on('click', '.nt_inner .banner__heading', function(e) {
  e.preventDefault();

  if ($(this).hasClass('active')) {
    $(this).removeClass('active');
  } else {
    $('.nt_inner .banner__heading').removeClass('active');
    $(this).addClass('active');
  }
});
$(document).on('click', '.close-hover', function(e) {
  e.preventDefault();
  const $hover = $(this).closest('.content__hover');
  $hover.addClass('hidden');
  $('.nt_inner .banner__heading').removeClass('active');
});

$(document).on('click', function(e) {
  if (
    !$(e.target).closest('.content__hover').length &&
    !$(e.target).closest('.banner__heading').length
  ) {
    $('.content__hover').addClass('hidden');
    $('.nt_inner .banner__heading').removeClass('active');
  }
});

   $('.button-click-change-scroll a[href^="#"]').on('click', function(e) {
    e.preventDefault();

    var target = $($(this).attr('href'));
    if (target.length) {
      $('html, body').animate({
        scrollTop: target.offset().top - 200
      }, 600); 
    }
  });
  $('.menu-drawer summary.menu-drawer__menu-item').on('click', function () {
    $('.menu-drawer').addClass('active');
  });
  $('.menu-drawer__close-button').on('click', function () {
    $('.menu-drawer').removeClass('active');
  });
  

var swiper = new Swiper('.slider-upsell', {
  slidesPerView: 1,
  spaceBetween: 10,
  loop: true,
  centeredSlides: true,
  autoplay: {
    delay: 3000,
    disableOnInteraction: false,
  },
  pagination: {
    el: '.swiper-pagination',
    clickable: true,
  }
});


  $().timelinr({
    arrowKeys: 'true'
  });
  $('.footer-block.has-dropdown .footer-block__heading').click(function (e) { 
      e.preventDefault();
      $(this).toggleClass('active');
    });
  ///// Tab Faq
  $(document).on('click','.acctab_title', function(e){
     if($(window).width() >= 768){
        $('.acctab_title').removeClass('active-accor');
        $(this).addClass('active-accor');
        $('.acc_tab-inner .acc-tab-content .tabs-content').removeClass('activemain-tab').hide();
        $($(this).attr('data-act-title')).addClass('activemain-tab').show();
     }else{
       $('.acctab_title').removeClass('active-accor');
        $(this).addClass('active-accor');
        $('.acc_tab-inner .acc-tab-content .tabs-content').removeClass('activemain-tab').hide();
        $($(this).attr('data-act-title')).addClass('activemain-tab').show();
        // $('.acc_tab-inner .acc-tab-content .tabs-content').removeClass('activemain-tab').hide();
        $('.acc_tab-inner .acc-tab-content').addClass('tab-content-show').show();
        $($(this).attr('data-act-title')).addClass('activemain-tab').show();
     }
  });
  $(document).on('click','.acc_tab-inner .acc-tab-content .back__arrow', function(e){
      $('.acc_tab-inner .acc-tab-content').removeClass('tab-content-show').show();
  });
  $('.acc-head').on('click', function() {
      if($(this).hasClass('active')) {
        $(this).siblings('.acc-content').slideUp();
        $(this).removeClass('active');
      }
      else {
        $('.acc-content').slideUp();
        $('.acc-head').removeClass('active');
        $(this).siblings('.acc-content').slideToggle();
        $(this).toggleClass('active');
      }
  });
  $(".acc-load-more").on("click", function() {
    const $container = $(this).closest(".acc-container");
    const $hiddenItems = $container.find(".hidden-acc");
    $hiddenItems.each(function() {
      $(this).removeClass("hidden-acc").css("display", "block");
    });
    $(this).parent().css("display", "none");
  });
  // var swiper = new Swiper('.slider-upsell', {
  //   slidesPerView: 1,
  //   spaceBetween:10,
  //   loop: true,
  //   centeredSlides: true,
  //   autoplay: {
  //     delay: 50000,
  //     disableOnInteraction: false,
  //   },
  //    navigation: {
  //     nextEl: '.upsell_products .swiper-button-next',
  //     prevEl: '.upsell_products .swiper-button-prev',
  //   }
  // });
   function setEqualHeight() {
    var maxHeight = 0;
    $('.collection .card__heading').css('height', 'auto');

    $('.collection .card__heading').each(function() {
        var currentHeight = $(this).outerHeight();
        if (currentHeight > maxHeight) {
            maxHeight = currentHeight;
        }
    });

    $('.collection .card__heading').each(function() {
        $(this).css('height', maxHeight + 'px');
    });
  }

  $(document).ready(function() {
      setEqualHeight();
  });
  
  $(window).on('resize', function() {
      setEqualHeight();
  });
  $('.product-card-toggle .toggle-option').on('click', function () {
  var $input = $(this).find('input');

  $input.prop('checked', true).trigger('change');

  var $toggle = $(this).closest('.product-card-toggle');
  var index = $(this).index();

  $toggle.find('input').each(function (i) {
    if (i === index) {
      $(this).prop('checked', true);
    } else {
      $(this).prop('checked', false);
    }
  });
});

// blog sorting
  $('.filter-blog-icon,.dropdown-title').click(function (e) { 
        e.preventDefault();
        $(this).toggleClass('active');
  });
  $("#sorting-dropdown").change(function() {
      var selectedOption = $(this).val();
      sortBlogPosts(selectedOption);
  });
  $('.blog-search').on('input', function(){
    var get_input = $(this).val().toLowerCase(); 
    var resultsCount = 0;
    $('.blog-articles__article').each(function(){
        var articleHeading = $(this).find('.card__heading a').text().toLowerCase();
        if(articleHeading.includes(get_input)){
            $(this).show();
            resultsCount++;
        }
        else{
            $(this).hide();
        }
    });
    if (resultsCount === 0) {
        $('.no-results-message').show();
    } else {
        $('.no-results-message').hide();
    }
  });

  function runSearch() {
      var get_input = $(".search-container.search-filter-block input").val().toLowerCase(); 
      var resultsCount = 0;
      $('.blog-articles__article').each(function(){
          var articleHeading = $(this).find('.card__heading a').text().toLowerCase();
          if(articleHeading.includes(get_input)){
              $(this).show();
            resultsCount++;
          } else {
              $(this).hide();
          }
      });
      $(".show_more_btn").hide();
      if (resultsCount === 0) {
        $('.no-results-message').show();
    } else {
        $('.no-results-message').hide();
    }
    }
    
    // Trigger when the search button is clicked
    $('.search-container.search-filter-block button.search-button').on('click', function() {
      runSearch();
    });
    
    // Trigger when Enter is pressed inside the input field
    $(".search-container.search-filter-block input").on('keypress', function(e) {
      if (e.which === 13) { // 13 is the Enter key code
        runSearch();
      }
    });
  
  // function sortBlogPosts(option) {
  //   var postsContainer = $(".blog-articles");
  //   var posts = postsContainer.children(".cust_sort_blog");
  
  //   switch (option) {
  //     case "title-ascending":
  //       posts.sort(function(a, b) {
  //         return $(a).find(".blog-post-title").text().localeCompare($(b).find(".blog-post-title").text());
  //       });
  //       break;
  //     case "title-descending":
  //       posts.sort(function(a, b) {
  //         return $(b).find(".blog-post-title").text().localeCompare($(a).find(".blog-post-title").text());
  //       });
  //       break;
  //     case "created-ascending":
  //       posts.sort(function(a, b) {
  //         var dateA = new Date($(a).find(".blog-post-date").text());
  //         var dateB = new Date($(b).find(".blog-post-date").text());
  //         return dateA - dateB;
  //       });
  //       break;
  //     case "created-descending":
  //       posts.sort(function(a, b) {
  //         var dateA = new Date($(a).find(".blog-post-date").text());
  //         var dateB = new Date($(b).find(".blog-post-date").text());
  //         return dateB - dateA;
  //       });
  //       break;
  //     default:
  //       // No sorting, maintain original order
  //       break;
  //   }
  //   postsContainer.empty().append(posts);
  // }
  const $loadMoreButton = $('[data-pagination-btn]');
    const $productGrid = $('.blog-articles');
    if ($loadMoreButton.length) {
        $loadMoreButton.on('click', function(e) {
            e.preventDefault();
            const nextUrl = $loadMoreButton.attr('href');

            $loadMoreButton.text("Laden...");
            $loadMoreButton.prop('disabled', true);

            $.get(nextUrl, function(response) {
                const $tempDiv = $('<div>').html(response);
                const newProductsHtml = $tempDiv.find('.blog-articles').html();

                $productGrid.append(newProductsHtml);

           

                const $newButton = $tempDiv.find('[data-pagination-btn]');
                const newHref = $newButton.attr('href');

                if ($newButton.length && newHref && newHref !== nextUrl) {
                    $loadMoreButton.attr('href', newHref);
                    $loadMoreButton.text("MEHR ANZEIGEN");
                    $loadMoreButton.prop('disabled', false);
                } else {
                    $loadMoreButton.text("Keine Produkte mehr").hide(); 
                }
            }).fail(function() {
                console.error('Error loading more products.');
                $loadMoreButton.text("Try again");
                $loadMoreButton.prop('disabled', false);
            });
        });
    }
});


document.addEventListener('DOMContentLoaded', function() {
    const loadMoreButton = document.querySelector('[data-pagination-btn]');
    const productGrid = document.getElementById('product-grid');
    
    if (loadMoreButton) {
        loadMoreButton.addEventListener('click', function(e) {
            e.preventDefault();
            const nextUrl = loadMoreButton.getAttribute('href');
            
            loadMoreButton.textContent = "Laden...";
            loadMoreButton.setAttribute('disabled', 'true');
            
            fetch(nextUrl)
                .then(response => response.text())
                .then(data => {
                    const tempDiv = document.createElement('div');
                    tempDiv.innerHTML = data;
                    
                    const newProducts = tempDiv.querySelector('#product-grid').innerHTML;
                    
                    productGrid.innerHTML += newProducts;
                    const count = productGrid.querySelectorAll('.grid__item').length;
                    let countDisplay = document.querySelector('p.products-count span.products-count');
                    countDisplay.innerHTML = count;
                    // var sliderProducts = document.querySelectorAll('.has-slider-wrapper');

                    // sliderProducts.forEach(function(slider) {
                    //     new Flickity(slider, {
                    //         pageDots: false,
                    //         freeScroll: false,
                    //         wrapAround: true,
                    //         prevNextButtons: true,
                    //         autoPlay: false,
                    //         groupCells: false,
                    //         cellAlign: 'center',
                    //     });
                    // });
                    
                    const newButton = tempDiv.querySelector('[data-pagination-btn]');
                  
                    if (newButton) {
                        loadMoreButton.setAttribute('href', newButton.getAttribute('href'));
                        loadMoreButton.textContent = "MEHR ARTIKEL ANZEIGEN";
                        loadMoreButton.removeAttribute('disabled');
                    } else {
                        loadMoreButton.textContent = "Keine Produkte mehr";
                        loadMoreButton.style.display = "none";
                    }
                })
                .catch(error => {
                    console.error('Error loading more products:', error);
                    loadMoreButton.textContent = "Try again";
                    loadMoreButton.removeAttribute('disabled');
                });
        });
    }
});
const params = new URLSearchParams(window.location.search);
if (params.get('open_cart_n') === '2') {
   const cartToggle = document.querySelector('#cart-icon-bubble');
    if (cartToggle) {
      cartToggle.click();
  }
  params.delete('open_cart_n');
  history.replaceState({}, '', `${location.pathname}?${params}`);
}



document.addEventListener("DOMContentLoaded", () => {
  const titles = document.querySelectorAll('.childlink--title');

  titles.forEach(title => {
    const originalText = title.innerHTML;
    
    if (originalText.includes('ß')) {
      const newText = originalText.replace(/ß/g, '<span class="special-beta">ß</span>');
      title.innerHTML = newText;
    }
  });
});




// load varaint 
$(window).on('load', function() {
  // Locate the script tag containing variant data
  const scriptTag = $('script[data-selected-variant]').first();

  if (scriptTag.length) {
    try {
      const jsonData = JSON.parse(scriptTag.text().trim());
      const featuredMediaId = jsonData.featured_media?.id;
      const sectionIdValue = $('input[name="section-id"]').val();
      
      // Ensure we have both IDs before proceeding
      if (featuredMediaId && sectionIdValue) {
        const mediaId = `${sectionIdValue}-${featuredMediaId}`;
        const thumbnail = $(`li[data-att="${mediaId}"]`);

        if (thumbnail.length) {
          console.log('Thumbnail found, waiting for Flickity...');

          // --- FIX: Polling mechanism to wait for Flickity initialization ---
          const checkFlickityInterval = setInterval(() => {
            const $gallery = $('.product-single__gallery');
            const flkty = $gallery.data('flickity');

            // Check if Flickity is fully initialized and has cells
            if (flkty && flkty.cells && flkty.cells.length > 0) {
              clearInterval(checkFlickityInterval); // Stop checking
              console.log('Flickity ready. Triggering click.');
              thumbnail.click(); // Trigger the click safely
            }
          }, 100); // Check every 100ms

          // Safety timeout: Stop checking after 5 seconds to prevent infinite loops
          setTimeout(() => {
            clearInterval(checkFlickityInterval);
          }, 1000);
        }
      }
    } catch (e) {
      console.error('Error parsing variant JSON:', e);
    }
  }
});


// load varaint 

